module.exports = __webpack_public_path__ + "img/title_txt_day1.6f872ccd.png";